import { createContext } from "react";
import type { MetadataCircuit } from "types";

/**
 * Scored circuits exposed for dashboard measure pickers only. Kept separate from
 * {@link MetadataStoreContext} (the global selectable store) so circuits surface in
 * dashboards without leaking into other consumers of that store (e.g. Charting).
 *
 * Defaults to an empty array (rather than throwing when unprovided) so circuits are a
 * purely additive concern — consumers outside {@link MetadataProvider} simply see no circuits.
 */
const MetadataCircuitsContext = createContext<MetadataCircuit[]>([]);
MetadataCircuitsContext.displayName = "MetadataCircuitsContext";

export default MetadataCircuitsContext;
